<p-table
  #dt1
  [value]="users"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="true"
  currentPageReportTemplate="Prikaz od {first}. do {last}. korisnika od ukupno {totalRecords}"
  [globalFilterFields]="['fname', 'lname', 'email', 'username']"
>
  <ng-template pTemplate="caption">
    <div class="page-control flex align-items-center">
      <div class="grid w-100">
        <div class="col-4 sm-4">
          <span class="p-input-icon-left w-100">
            <i class="pi pi-search"></i>
            <input
              pInputText
              class="w-100"
              type="text"
              (input)="dt1.filterGlobal($event.target.value, 'contains')"
              placeholder="Pretraži ime, korisničko ime, email"
            />
          </span>
        </div>
        <div class="col-8">
          <div class="p-input">
            <p-selectButton
              [options]="usersTypes"
              ngModel="active"
              optionLabel="label"
              (onChange)="onChangeUsersType($event.value)"
              optionValue="value"
            ></p-selectButton>
          </div>
        </div>
      </div>

      <div class="btn-group">
        <a
          [routerLink]="['add']"
          class="main-btn add-new-btn"
        >Dodaj korisnika <i class="pi pi-plus"></i></a>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th>
        <div class="flex justify-content-center align-items-center">
          Ime i prezime
        </div>
      </th>
      <th>
        <div class="flex justify-content-center align-items-center">
          Korisničko ime
        </div>
      </th>
      <th>
        <div class="flex justify-content-center align-items-center">E-mail</div>
      </th>
      <th>
        <div class="flex justify-content-center align-items-center">Uloga</div>
      </th>
      <th style="width: 8rem">
        <div class="flex align-items-center">Akcija</div>
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-user
  >
    <tr>
      <td>
        <span class="image-text">{{ user.fname }} {{ user.lname }}</span>
      </td>
      <td>
        <span class="image-text">{{ user.username }}</span>
      </td>
      <td>
        {{ user.email }}
      </td>
      <td>
        {{ user.role_id | role }}
      </td>
      <td class="text-center">
        <ng-container *ngIf="!user.deleted_at">
          <a
            class="second-btn small-btn mr-2"
            pTooltip="Izmeni"
            tooltipPosition="top"
            (click)="onEditUser(user)"
            [routerLink]="['edit']"
          >
            <i class="pi pi-pencil"></i>
          </a>
          <button
            class="second-btn small-btn"
            type="button"
            pTooltip="Izbriši"
            tooltipPosition="top"
            (click)="onDeleteUser($event, user.id)"
          >
            <i class="pi pi-trash"></i>
          </button>
        </ng-container>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">Ni jedan korisnik nije pronađen.</td>
    </tr>
  </ng-template>
</p-table>
